import { Component, OnInit } from '@angular/core';
import { WidgetService } from '../widget.service';
import { Paginator } from '../../models/paginator';
import { Widget, WidgetStatus } from '../../models/widget';

@Component({
  selector: 'cw-widget-list',
  templateUrl: './widget-list.component.html',
})
export class WidgetListComponent implements OnInit {
  paginator: Paginator<Widget>;
  statuses: any[] = [
    {
      key: WidgetStatus.Published,
      name: 'Publicerade',
    },
    {
      key: WidgetStatus.Draft,
      name: 'Utkast',
    },
    {
      key: WidgetStatus.Archived,
      name: 'Arkiverade',
    }
  ];
  activeStatus: WidgetStatus = WidgetStatus.Published;
  searchStr: string;

  constructor(private widgetService: WidgetService) {
  }

  onSearchStrChange(str: any) {
  }

  ngOnInit() {
    this.widgetService.get().subscribe(paginator => {
      this.paginator = paginator;
    });
  }

  setActiveStatus(status: WidgetStatus) {
    this.activeStatus = status;
  }

}



// WEBPACK FOOTER //
// ./src/app/widgets/widget-list/widget-list.component.ts